import { render, staticRenderFns } from "./editHeader.vue?vue&type=template&id=5e622072&scoped=true"
import script from "./editHeader.vue?vue&type=script&lang=js"
export * from "./editHeader.vue?vue&type=script&lang=js"
import style0 from "./editHeader.vue?vue&type=style&index=0&id=5e622072&prod&lang=less&scoped=true"
import style1 from "./editHeader.vue?vue&type=style&index=1&id=5e622072&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e622072",
  null
  
)

export default component.exports